import { translateNested } from "app/pages/sales-intelligence/utils/common";

/** @deprecated use direct import from `app/pages/sales-intelligence/utils/common` */
export default translateNested;
